import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'bonus-comp',
  templateUrl: '../sharedTemplates/bonus.html',
})
export class Bonus {
  public bonusTrackerResult = [];
  public bonusTracker1Result = [];
  public bonusOnlineTracker1Result = [];

  bonusDropDownIsOpen = true;
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper
  ) {}

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Bonus', true);
    this.getProcCustomerBonusTrackerResult();
    this.getProcCustomerBonusTracker1Result();
    this.getProcCustomerBonusOnlineTracker1Result();
  }

  getProcCustomerBonusTrackerResult() {
    this._ApiService.getProcCustomerBonusTrackerResult().then(x => {
      this.bonusTrackerResult = x;
    });
  }

  getProcCustomerBonusTracker1Result() {
    this._ApiService.getProcCustomerBonusTracker1Result().then((x: any) => {
      this.bonusTracker1Result = x;
    });
  }
  getProcCustomerBonusOnlineTracker1Result() {
    this._ApiService.getProcCustomerBonusOnlineTracker1Result().then((x: any) => {
      this.bonusOnlineTracker1Result = x;
    });
  }
  toggleDropDown() {
    this.bonusDropDownIsOpen = !this.bonusDropDownIsOpen;
  }
}
